export default "__VITE_ASSET__10d646e0__"